module.exports = __webpack_public_path__ + "static/media/clubbingcharges.fc13c84e.xlsx";